<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="directiveRecords">
			<template #ops>
				<el-button v-if="false" v-click-blur style="width: 100px" type="primary" @click="handleExportExcel">
					导出记录
				</el-button>
			</template>
		</gc-header>
		<div class="run-main directive-content">
			<div class="right">
				<div class="filter">
					<gc-advanced-filter
						v-model="form"
						:fields="filterFields"
						@search="handleQuerySearch"
						@reset="handleQueryReset"
					/>
					<gc-column-setting
						:storageKey="`localcolumn-directive-records`"
						:columns="columns"
						@update-column="data => (columns = data)"
					></gc-column-setting>
				</div>
				<div class="table">
					<gc-table
						border
						showPage
						:columns="columnList"
						:table-data="tableData"
						:current-page.sync="pagination.currentPage"
						:total="pagination.total"
						:pageSize="pagination.pageSize"
						gloabSortDisable
						@current-page-change="handleCurrentPageChange"
						@size-change="handlePageSizeChange"
					></gc-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs'
import { handleParams } from '@/utils'
import { isBlank } from '@/utils/validate'
import { exportReport } from '@/apis/statisticAnalysis.api'
import { apiGetDeviceTypeList, apiCancelCommand } from '@/apis/account.api'
import { apiGetCommandRecordList, apiGetDeviceIotDetails } from '@/apis/batchDirectiveManage.api'

const getDefaultCreateTime = () => [
	dayjs().subtract(6, 'day').format('YYYY-MM-DD') + ' 00:00:00',
	dayjs().format('YYYY-MM-DD') + ' 23:59:59',
]

export default {
	data() {
		return {
			form: {
				taskNo: null,
				deviceTypeClassify: null,
				deviceTypeIdList: null,
				cmdClass: null,
				status: null,
				createTime: getDefaultCreateTime(),
			},
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
			columns: [
				{
					key: 'deviceNo',
					name: '设备通讯编号',
					fixed: 'left',
					dragDisable: true,
					disabledSelect: true,
					tooltip: true,
				},
				{
					key: 'deviceTypeName',
					name: '设备类型',
					tooltip: true,
				},
				{
					key: 'cmdName',
					name: '指令名称',
					tooltip: true,
				},
				{
					key: 'cmdClass',
					name: '指令类型',
					tooltip: true,
				},
				{
					key: 'status',
					name: '指令状态',
					render: (h, row) => {
						const statusMap = {
							0: { class: 'dot-warning', text: '待执行' },
							1: { class: 'dot-success', text: '成功' },
							2: { class: 'dot-error', text: '失败' },
							3: { class: 'dot-error', text: '人工取消' },
						}
						const val = row.status
						return h(
							'span',
							{ class: isBlank(val) ? '' : statusMap[val]?.['class'] },
							isBlank(val) ? '--' : statusMap[val]?.['text'],
						)
					},
				},
				{
					key: 'createTime',
					name: '创建时间',
					width: 200,
				},
				{
					key: 'endTime',
					name: '更新时间',
					width: 200,
				},
				{
					key: 'msgSource',
					name: '指令来源',
				},
				{
					key: 'cmdUserInfo',
					name: '操作员',
				},
				{
					key: 'cmdCancelUserInfo',
					name: '取消操作员',
				},
				{
					key: 'taskNo',
					name: '任务编号',
				},
				{
					key: 'operate',
					name: '操作',
					minWidth: 200,
					fixed: 'right',
					render: (h, row) => {
						const style = {
							fontSize: '14px',
							color: '#4A69FF',
							marginRight: '12px',
							cursor: 'pointer',
						}
						const ops = [
							h(
								'span',
								{
									style,
									on: {
										click: () => this.handleToDeviceDetails(row),
									},
								},
								'查看详情',
							),
							row.status === '0' &&
							row.msgSource === 'iot-web' &&
							this.$has('monitor:command:ledger:cmdmodel:cancel')
								? h(
										'span',
										{
											style: { ...style, color: '#e5662e' },
											on: {
												click: () => this.handleCancelCommand(row),
											},
										},
										'取消发送',
								  )
								: null,
						].filter(Boolean)
						return h('div', null, ops)
					},
				},
			],
			deviceTypeOptions: [],
			pickerOptions: {
				disabledDate(date) {
					const now = new Date()
					const lastMonthYear = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear()
					const lastMonth = now.getMonth() === 0 ? 11 : now.getMonth() - 1
					const lastMonthFirstDay = new Date(lastMonthYear, lastMonth, 1)
					return date < lastMonthFirstDay
				},
			},
			exportParams: null,
		}
	},

	created() {
		this.queryTableDataPageList()
	},

	methods: {
		async queryDeviceTypeList() {
			try {
				const data = await apiGetDeviceTypeList({
					tenantId: this.tenantId,
					deviceTypeClassify: this.form.deviceTypeClassify,
				})
				this.deviceTypeOptions = (data?.records || []).map(item => {
					return {
						value: item.deviceTypeId,
						label: item.deviceTypeName,
					}
				})
			} catch (error) {
				this.deviceTypeOptions = []
			}
		},

		async queryTableDataPageList() {
			if (!this.form.createTime?.length) return this.$message.warning('请选择创建时间范围')
			this.loading = true
			const searchParams = handleParams({
				...this.form,
				startTime: this.form.createTime?.[0],
				endTime: this.form.createTime?.[1],
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
				createTime: undefined,
			})
			this.exportParams = { ...searchParams, current: undefined, size: undefined }
			try {
				const { records = [], total } = await apiGetCommandRecordList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryTableDataPageList()
		},

		handlePageSizeChange(size) {
			this.pagination.currentPage = 1
			this.pagination.pageSize = size
			this.queryTableDataPageList()
		},

		handleQuerySearch() {
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		handleQueryReset() {
			for (const key in this.form) {
				if (key === 'createTime') {
					this.form.createTime = getDefaultCreateTime()
				} else {
					this.form[key] = null
				}
			}
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		async handleCancelCommand(row) {
			await this.$confirm('一旦取消不可撤回操作，请确认是否取消该指令？')
			await apiCancelCommand({ cmdId: row.cmdId, deviceNo: row.deviceNo, iotDeviceId: row.deviceId })
			this.$message.success('指令取消成功')
			this.queryTableDataPageList()
		},

		async handleToDeviceDetails(row) {
			const data = await apiGetDeviceIotDetails(row.deviceId)
			this.$router.push({
				name: 'deviceDetail',
				query: {
					deviceId: data.deviceId,
					deviceType: data.deviceTypeId,
				},
				params: {
					name: 'DirectiveRecord',
				},
			})
		},

		handleExportExcel() {
			if (!this.tableData.length) return this.$message.warning('暂无表格数据')
			const startTime = new Date(this.exportParams.startTime).getTime()
			const endTime = new Date(this.exportParams.endTime).getTime()
			if ((endTime - startTime) / 1000 / 60 / 60 / 24 > 7)
				return this.$message.warning('导出数据时间区间不能超过7天')
			this.$toast('下载中，请稍后...')
			const data = {
				method: 'post',
				url: '/monitor/report/command/list/export/excel',
				fileName: '指令记录.xlsx',
				data: this.exportParams,
			}
			exportReport(data, 'excel', '', this.$toast)
		},
	},

	computed: {
		columnList() {
			return this.columns.filter(o => o.selected)
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		deviceTypeClassifyOptions() {
			return this.$store.getters.dataList.deviceTypeClassify || []
		},

		cmdStatusOptions() {
			return this.$store.getters.dataList.commandStatus || []
		},

		cmdNameOptions() {
			return this.$store.getters.dataList.cmdClass || []
		},

		filterFields() {
			return [
				{
					prop: 'taskNo',
					label: '任务编号',
					type: 'input',
				},
				{
					prop: 'deviceTypeClassify',
					label: '设备大类',
					type: 'select',
					props: {
						searchOption: this.deviceTypeClassifyOptions,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.deviceTypeOptions,
						filterable: true,
						needAllForSearch: true,
						multiple: true,
					},
				},
				{
					prop: 'cmdClass',
					label: '指令类型',
					type: 'select',
					props: {
						searchOption: this.cmdNameOptions,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'status',
					label: '指令状态',
					type: 'select',
					props: {
						searchOption: this.cmdStatusOptions,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'createTime',
					label: '创建时间',
					type: 'date',
					defaultValue: getDefaultCreateTime(),
					props: {
						required: true,
						datePickerType: 'datetimerange',
						valueFormat: 'yyyy-MM-dd HH:mm:ss',
						clearable: false,
						pickerOptions: this.pickerOptions,
					},
				},
			]
		},
	},

	watch: {
		'form.deviceTypeClassify': {
			handler() {
				this.form.deviceTypeIdList = null
				this.queryDeviceTypeList()
			},
			immediate: true,
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
.directive-content {
	flex-direction: row;
	padding: 0 12px;
	.left {
		width: 300px;
		height: 100%;
		padding: 20px 8px 8px 0;
		border-right: 1px solid #f1f1f1;
		& + .right {
			padding-left: 12px;
		}
	}
	.right {
		flex: 1;
		width: 0;
		display: flex;
		height: 100%;
		flex-direction: column;
		.filter {
			display: flex;
			flex-wrap: wrap;
			padding: 12px 0;
		}
		.table {
			flex: 1;
			height: 0;
		}
	}
}
</style>
